import { FacetFilter, FacetFilterType, useAxios, useFacetsFilters } from '@/app/composable';
import { ModelAPI } from '@/modules/asset/api';
import { computed, ref } from '@vue/composition-api';

export function useMarketplaceFacets(get: any) {
    const { exec } = useAxios(true);

    const { reducedFacetsFilters, defaultValue } = useFacetsFilters();

    const conceptsByUid = ref<any>([]);

    exec(ModelAPI.conceptsUidMap()).then((res: any) => {
        conceptsByUid.value = res.data;
    });

    const marketplaceFacets = computed(
        (): Record<string, FacetFilter> => ({
            category: {
                label: 'Category',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'category'),
                valueLabel: (uid: string) => {
                    if (conceptsByUid.value[uid]) return conceptsByUid.value[uid].name;
                    return uid;
                },
            },
            accessibility: {
                label: 'Accessibility',
                type: FacetFilterType.Checkbox,
                default: defaultValue(get, 'accessibility'),
            },
        }),
    );

    const reducedMarketplaceFacets: any = reducedFacetsFilters(marketplaceFacets);

    return { marketplaceFacets, reducedMarketplaceFacets };
}
